import React, { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface PermissionGateProps {
  children: ReactNode;
  requireWrite?: boolean;
  requireAdmin?: boolean;
  fallback?: ReactNode;
}

/**
 * Conditional rendering component based on user permissions.
 *
 * Usage:
 *   <PermissionGate requireWrite>
 *     <button>Create Project</button>
 *   </PermissionGate>
 *
 *   <PermissionGate requireAdmin fallback={<span>Admin only</span>}>
 *     <AdminPanel />
 *   </PermissionGate>
 */
export const PermissionGate: React.FC<PermissionGateProps> = ({
  children,
  requireWrite = false,
  requireAdmin = false,
  fallback = null
}) => {
  const { canWrite, isAdmin } = useAuth();

  if (requireAdmin && !isAdmin()) {
    return <>{fallback}</>;
  }

  if (requireWrite && !canWrite()) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default PermissionGate;
